import * as Html from "../../util/Html.ts";
import * as modal from "../../util/modal.ts";
import * as amplify from "../../util/amplify.ts";
import ApiServer from "../../ApiServer.js";
import * as FwDatas from "../../FwDatas.ts";
import * as actionMenu from "../action-menu-registry.ts"
import * as i18n from "../../i18n.ts"
import { TaskListCache } from "../../server/objects/TaskBeans.ts";
export {init}
Html.registerWidget('widget/form/taskedit',{init:init})


actionMenu.register({
  tasklistselect(){
    return {menu:TaskListCache.datas.map(list=>{return {svg:list.svg,iconclass:"color-branded",title:list.name,value:list.metaId,onclick:"actionmenupick|"+list.metaId}})};
  }
})

ApiServer['custom.taskupdate'] = ApiServer.taskupdate2.prepare(function(){
  modal.closeModal();
  amplify.publish('taskNeedRefresh')
  amplify.publish("activityUpdated");
});
ApiServer['custom.taskcreate'] = ApiServer.taskcreate2.prepare(function(){
  modal.closeModal();
  amplify.publish('taskNeedRefresh')
  amplify.publish("activityUpdated");
});
function init(node){
  if(node.metaId()){
    node.find('form').attr('data-fw-dyn-action','custom.taskupdate')
  }else{
    node.find('form').attr('data-fw-dyn-action','custom.taskcreate')
  }
  var dueDate = node.find('input[name="dueDate"]');
  function onDueDateChange(){
    var 
      active = (dueDate.get(0).value!=='$empty'),
      reminderBlock = node.find('.fw-reminder-block');
    reminderBlock.toggle(active);
    if(!active){
      reminderBlock.find("select").val('').trigger('change');
    }
  }
  
  var 
    taskListIdSelect = node.find("[name='taskListId']"),
    taskCategorySelect = node.find("[name='taskCategoryId']"),
    taskCategoryId = taskCategorySelect.attr("data-value");
  
  function majCategory(){
    let 
      taskListId = taskListIdSelect.val(),
      taskList = FwDatas.get(taskListId);
    if(taskCategorySelect.val()){
      taskCategoryId = taskCategorySelect.val()
    }
    taskCategorySelect.html('<option value="">🏷️ '+Html.escape(i18n.get('catsystem.uncategorized'))+'</option>'+taskList.getCategories(true).map(cat=>
      '<option value="'+cat.metaId+'" '+(taskCategoryId===cat.metaId?'selected':'')+'>'+Html.escape(cat.emoji+' '+cat.name)+'</option>'
    ).join(''));
    
  }
  taskListIdSelect.on('change',majCategory);
  dueDate.on('change',onDueDateChange);
  //we do it later to make sure it has been initialized
  setTimeout(function(){
    onDueDateChange();
    majCategory();
  },10)
}